import { render, staticRenderFns } from "./customMultiselect.vue?vue&type=template&id=3f61a31a&"
import script from "./customMultiselect.vue?vue&type=script&lang=js&"
export * from "./customMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./customMultiselect.vue?vue&type=style&index=0&id=3f61a31a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports